query TranslationsOptions {
  translationsOptions {
    value
    label
  }
}
